import { configureStore } from "@reduxjs/toolkit";
import areaGroupReducer from "./area-group";
import geojsonReducer from "./geojson";
import territoryReducer from "./territory";
import uiStateReducer from "./ui-state";
export default configureStore({
  reducer: {
    areaGroupReducer,
    geojsonReducer,
    territoryReducer,
    uiStateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
